import sum from 'ramda/src/sum'
import pluck from 'ramda/src/pluck'

/** @param {string} display */
export const selectMode = display => {
  switch (display) {
    case 'overview':
    case 'standard':
      return 'standard'
    case 'actual':
      return 'actual'
    default:
      return 'standard'
  }
}

/** @param {number} n */
export const determineColor = n => {
  if (typeof n === 'string') {
    // parseFinancial() ?
    n = Number(+n.replace(/,|[a-z]|[A-Z]/g, ''))
  }

  if (n > 0) return '#d9534f'
  if (n < 0) return '#5cb85c'
  return ''
}

/**
 * @param {object} props
 * @param {number} props.forecast
 * @param {number} props.actual
 * @param {number} props.remaining
 * @param {number} props.initial
 * @param {number} props.current
 * @returns {'red' | 'orange' | 'green'}
 */
export function determineStatusColor({ forecast, current, initial, remaining, actual }) {
  if (remaining < 0) return determineBy(actual)
  return determineBy(forecast)

  function determineBy(value) {
    if (value > current) return 'red'
    if (value > initial) return current ? 'orange' : 'red'

    return 'green'
  }
}

/** @param {string[]} colors */
export const totalAboveValueColorTrigger = colors => (bars, marker) => {
  return sum(pluck('value', bars).map(x => (x <= 0 ? 0 : x))) <= marker.value
    ? bars
    : bars.map((bar, idx) => ({ ...bar, color: colors[idx] }))
}



// WEBPACK FOOTER //
// ./src/pages/project-profit-sheet/model.js